module.exports = __webpack_public_path__ + "files/668d0a0e7a0189f62898bcc57ab8370c.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-colorpicker/dist/img/bootstrap-colorpicker/saturation.png
// module id = 1109
// module chunks = 76